import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { Reagendamento } from '../domain/reagendamento.model';

export class ReagendamentoSerializer extends DomainSerializer<Reagendamento> {}
